import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Register } from '../../_models/register';
import { Caller } from '../../_models/caller';
import { OrderMenu } from '../../_models/orderMenu';
import { AlertService } from '../../_services/alert.service';
import { AccessSecurity } from '../../_models/accessSecurity';


@Component({
  selector: 'app-inventories',
  templateUrl: './inventories.component.html',
  styleUrls: ['./inventories.component.css']
})
export class InventoriesComponent implements OnInit {
  inventoriesMainMenu: OrderMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N" },
    {
      displayName: "Active", tabClicked: "active", orderStatus: "ACTIVE", additional: "N"
    },
    {
      displayName: "Inactive", tabClicked: "inactive", orderStatus: "IN_ACTIVE", additional: "N"
    }
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  tabClicked: string;
  status: string;
  statusText1: string = "";
  statusText2: string = "";
  uploadDismissModal: string = "";
  uploadPopup: string = "";
  accountOwnerId: string;
  productType: string;
  products: any;
  onHandQuantityRecords: any;
  productImage: string = "";
  errorMessage: string;
  displayMsg: string;
  checkedList: any;
  loading = true;
  totalCount: any;
  quantityError: any;
  selectImport: string = "PRODUCTS";
  c: any;
  masterSelected: boolean = false;
  productStatus: any = 'ALL';
  previousStatus = '';
  totalRecords: number;
  checkedListView = [];
  displayPopUP: string = 'N';
  barCodePopUP: string = 'N';
  userDrop2: any = 'ALL';
  statusUpdate: string = 'N';
  productInfo: any;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User, public register: Register, public caller: Caller, public accessSec: AccessSecurity) {
    this.g.page = "Products";
    this.tabClicked = this.g.pageTab;
    this.g.accountOwnerName = this.user.accountOwnerName;
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      if (this.tabClicked !== "all") {
        this.getProductsCount();
      }
      for (let ol of this.inventoriesMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData('all', "ALL");
    }
  }

  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  switchPosition(om) {
    let index = this.inventoriesMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.inventoriesMainMenu[5].displayName) {
      this.inventoriesMainMenu[5].additional = 'Y';
    }
    var tmp = 4;
    for (let o of this.inventoriesMainMenu) {
      if (tmp < this.inventoriesMainMenu.length) {
        if (om.displayName !== this.inventoriesMainMenu[tmp].displayName) {
          this.inventoriesMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }


  populate(orderChange) {

    this.api.getProductsByStatusAndOrgIdAndAOId(this.user.accountOwnerId, "1", orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.products = data.productsList;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });

  }

  selectedOnHandQuantity(records) {
    this.onHandQuantityRecords = records;
  }

  getProductsCount() {
    this.api.getProductsByStatusAndOrgIdAndAOId("1", this.user.accountOwnerId, 'ALL').subscribe((data: any) => {
      if (data) {
        this.totalCount = data.noOfProducts;
      }
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  getProductsByStatus(status) {

    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Product Name / SKU / Store SKU / HSN Code'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.productStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.productStatus;
        }
        let query: any = {
          status: this.productStatus,
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER" || this.user.role === "DEMO_ACCOUNT") {
          query.accountOwnerId = this.user.accountOwnerId;
        } else {
          this.router.navigate(['/admin/dashboard']);
        }
        let apiMethod = 'api/getProductsByStatusAndOrgIdAndAOId';
        if (this.productStatus == 'BACK_ORDERED') {
          apiMethod = 'api/getProductsWithBackOrdered/' + this.user.accountOwnerId + '/1';
        }
        if (this.productStatus == 'LOW_STOCK' || this.productStatus == 'BACK_ORDERED' || this.productStatus == 'OUT_OF_STOCK') {
          delete query.organizationId;
          delete query.accountOwnerId;
          delete query.status;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.g.loaderDisplay = "display";
        this.loading = true;
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.g.loaderDisplay = "";
            this.loading = false;
            if (this.productStatus === 'ALL' && !query.searchString) {
              this.totalCount = resp.noOfProducts;
            }
            if (apiMethod === 'api/getProductsByStatusAndOrgIdAndAOId') {
              this.products = resp.productsList;
            } else {
              this.products = resp.productList;

            }
            this.totalRecords = resp.noOfProducts;
            if (this.totalRecords == 0) {
              this.displayMsg = 'No matching records found';
            } else {
              this.displayMsg = '';
            }
            this.products.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfProducts,
              recordsFiltered: resp.noOfProducts
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.loading = false;
              this.alertService.error('Error', err);
            });
      }
    };

  }

  copied(event) {
    if (event.isSuccess) {
    }
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }


  populateTabData(triggered, productStatus) {
    this.tabClicked = triggered;
    this.productStatus = productStatus;
    if (!this.previousStatus) {
      this.getProductsByStatus(productStatus);
    } else {
      this.rerender();
    }
  }

  updateStatus(data) {
    this.productInfo = data;
    this.statusUpdate = 'Y';
  }

  changeStatus() {
    this.g.loaderDisplay = "display";
    if (this.productInfo.status == "ACTIVE") {
      this.productInfo.status = "IN_ACTIVE";
      this.rerender();
    } else {
      this.productInfo.status = "ACTIVE";
      this.rerender();
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeProductStatus', {
      "accountOwnerId": this.user.accountOwnerId,
      "productId": this.productInfo.productId,
      "organizationId": 1,
      "status": this.productInfo.status
    },
      { headers: header1 }).subscribe(data => {
        this.statusUpdate = 'N';
        if (data['code'] == "200") {
          this.alertService.success('Product', 'Status Updated Successfully');
          if (this.tabClicked == 'active' || this.tabClicked == 'inactive') {
            let index = this.products.indexOf(this.productInfo);
            this.products.splice(index, 1);
            //this.products.splice(index, 1);
            this.rerender();
          } else if (this.tabClicked == 'all') {
            this.rerender();
          }
        } else {
          if (this.productInfo.status == "ACTIVE") {
            this.productInfo.status = "IN_ACTIVE";
          } else {
            this.productInfo.status = "ACTIVE";
          }
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.statusUpdate = 'N';
        });
  }

  loadorder(event) {
    this.statusText2 = "";
    this.productImage = event.target.files[0];
  }

  submitImportProduct() {
    //  this.statusText2 = "";
    this.g.loaderDisplay = "display";
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#buttonModal";
    const file = this.productImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadFileToSaveProducts/' + this.user.organizationId + '?accountOwnerId=' + this.user.accountOwnerId, formData, { headers: headerObj }).subscribe(data => {

      if (data['code'] == 200) {
        this.g.loaderDisplay = "";
        this.alertService.success('Product', 'Submitted Successfully');
        this.reset();
        this.populateTabData('all', 'ALL');
      } else if (data['code'] == 400) {
        this.g.loaderDisplay = "";
        this.populateTabData('all', 'ALL');
        this.alertService.error('Error', data['message']);
        this.reset();
        return false;
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.uploadDismissModal = "";
        this.uploadPopup = "#";
      });
  }

  submitAdmin() {
    this.caller.parent = "INVENTORY"
    if (this.user.role === 'ROLE_ADMIN') {
      this.router.navigate(['/admin/accountOwner']);
    } else {
      this.router.navigate(['/admin/createInventory']);
    }

  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.products.length; i++) {
      this.products[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.products.length; i++) {
      if (this.products[i].isSelected) {
        this.checkedList.push(this.products[i]['productId']);
      }
    }
  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  }

  editProduct(products) {
    let i = 0;
    let ohid;
    for (let j of products) {
      if (j.isSelected) {
        i = i + 1;
        ohid = j.productId;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/editInventory/' + ohid]);
    } else {
      this.errorMessage = "Can not edit multiple products at once. Please select one at a time";
    }
  }

  reset() {
    this.selectImport = "PRODUCTS";
    this.removeFile();
  }

  removeFile() {
    this.productImage = "";
  }

  closepopUpRequest() {
    this.statusUpdate = 'N'
    this.populateTabData(this.tabClicked, this.productStatus);
  }

  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }
}
